import styled from "styled-components";
import { theme } from "../../../config";

export const Main = styled.div`
  ${theme.mainContainerStyle}

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  @media ${theme.breakpoints.mobile} {
    overflow-x: hidden;
    ${theme.hideScrollbar}
    flex-direction: row;
    align-items: flex-start;
  }
`;
